import {
  useAddProductTableData,
  useGetShelfByWarehouseId
} from "../../../../entities/inbound/useAddProductTable.js";
import {axios} from "../../../../lib/axios.js";
import {usePagination} from "../../../../entities/usePagination.js";
import {useUpdateRoute} from "../../../../lib/useIframe.js";
import {useIntlTyped} from "../../../../lib/useIntlTyped.js";
import {Button, Table, message, Typography, Tooltip} from "../../../../../__snowpack__/pkg/antd.js";
import React, {useEffect, useRef} from "../../../../../__snowpack__/pkg/react.js";
import styled from "../../../../../__snowpack__/pkg/styled-components.js";
import {localeMessage} from "../../i18n.js";
import {useSelectedKeysModel} from "../../store.js";
import {handleError} from "../../../../lib/errorHandler.js";
import {useAddProductToWarehouse} from "../../../../entities/stock/useAddProductToWarehouse.js";
export const MainContent = (props) => {
  const {data: shelfList} = useGetShelfByWarehouseId({
    warehouseId: props.selectedWarehouse?.id || ""
  });
  const didMountRef = useRef(false);
  const {formatMessage, formatMessageRaw} = useIntlTyped(localeMessage);
  const {updateRoute} = useUpdateRoute();
  const {pageInfo, setPageInfo, resetPageInfo} = usePagination(0, 10);
  const {tableData, setTableData, tableDataLoading, fetchTableData} = useAddProductTableData(props.orderType);
  const {selectedKeys, setSelectedKeys} = useSelectedKeysModel();
  const updateHandler = async (curPageInfo) => {
    const {pageInfo: pageInfo2} = await fetchTableData(curPageInfo, {
      ...props.search
    });
    if (pageInfo2) {
      setPageInfo(pageInfo2.page, pageInfo2.pageSize, pageInfo2.pageTotal);
    }
  };
  useEffect(() => {
    if (props.search && didMountRef.current) {
      const pageInfo2 = resetPageInfo();
      setSelectedKeys([]);
      updateHandler(pageInfo2);
    }
  }, [props.search]);
  useEffect(() => {
    didMountRef.current = true;
  }, []);
  const {
    data: addProductResult,
    fetchData: doAddProductToWarehouse,
    loading: addProductToWarehouseLoading
  } = useAddProductToWarehouse();
  const handleAddProductToWarehouse = async (record, index) => {
    try {
      const res = await doAddProductToWarehouse([
        {
          masterVariationId: record.masterVariationId || "",
          warehouseId: props.selectedWarehouse.id || "",
          masterSku: record.sku || void 0
        }
      ]);
      if (res && res.code === "SUCCESS") {
        const taskId = res.data || "";
        if (!taskId)
          return;
        await new Promise((resolve) => {
          setTimeout(() => {
            resolve(0);
          }, 500);
        });
        const maxTry = 100;
        let tryCount = 0;
        const checkTaskResult = async () => {
          const res1 = await axios.get(`/saas/ims/tasks?taskId=${taskId}`);
          if (res1 && res1.code === "SUCCESS") {
            if (res1.data?.status === "finish") {
              if (res1.data?.successNum >= 1) {
                message.success(formatMessage({id: "operationSuccessful"}));
                await updateHandler(pageInfo);
              } else {
                message.error(formatMessage({id: "failed"}));
                await updateHandler(pageInfo);
              }
            } else {
              await new Promise((resolve) => {
                setTimeout(() => {
                  resolve(0);
                }, 1e3);
              });
              if (++tryCount <= maxTry) {
                checkTaskResult();
              }
            }
          }
        };
        checkTaskResult();
      }
    } catch (error) {
      handleError(error);
    }
  };
  return /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement(Table, {
    dataSource: tableData,
    rowKey: (record) => record.masterVariationId,
    scroll: {x: 580, y: "calc(100vh - 390px)"},
    sticky: true,
    loading: tableDataLoading,
    rowSelection: void 0,
    pagination: {
      showTotal: (total) => formatMessageRaw({id: "globalsTotalPage"}, {total}),
      showQuickJumper: true,
      current: pageInfo.page,
      pageSize: pageInfo.pageSize,
      total: pageInfo.pageTotal,
      showSizeChanger: true,
      pageSizeOptions: ["10"],
      onChange: (page, pageSize) => {
        const pageInfo2 = setPageInfo(page, pageSize);
        updateHandler(pageInfo2);
        window.scrollTo(0, 0);
      }
    }
  }, /* @__PURE__ */ React.createElement(Table.Column, {
    title: formatMessage({id: "mskuAndBarcode"}),
    dataIndex: "sku",
    width: 110,
    fixed: "left",
    ellipsis: {showTitle: false},
    render: (text, record) => {
      let masterSku;
      if (props.orderType === "OUTBOUND") {
        masterSku = record.masterVariation?.masterSku || "";
      } else {
        masterSku = record.sku || "";
      }
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Tooltip, {
        placement: "topLeft",
        title: /* @__PURE__ */ React.createElement("span", null, masterSku ?? "-", record.barcode && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("br", null), formatMessage({id: "barcode"}) + ": " + record.barcode))
      }, masterSku ?? "-", record.barcode && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("br", null), formatMessage({id: "barcode"}) + ": " + record.barcode)));
    }
  }), /* @__PURE__ */ React.createElement(Table.Column, {
    title: formatMessage({id: "productName"}),
    dataIndex: "inventoryName",
    width: 120,
    ellipsis: {showTitle: false},
    render: (text, record) => {
      const productName = props.orderType === "OUTBOUND" ? record.masterVariation?.name : text;
      return /* @__PURE__ */ React.createElement(Tooltip, {
        placement: "topLeft",
        title: productName ?? "-"
      }, productName || "-");
    }
  }), /* @__PURE__ */ React.createElement(Table.Column, {
    title: formatMessage({id: "location"}),
    dataIndex: "warehouseShelfCode",
    width: 130,
    ellipsis: {showTitle: false},
    render: (text, record) => {
      if (props.orderType === "INBOUND") {
        if (!(Array.isArray(record.warehouseInventoryBriefs) && record.warehouseInventoryBriefs.length && record.warehouseInventoryBriefs[0]?.shelfInventoryBriefList)) {
          return "-";
        } else {
          return /* @__PURE__ */ React.createElement(React.Fragment, null, record.warehouseInventoryBriefs[0].shelfInventoryBriefList?.filter((data) => {
            return props.orderType === "OUTBOUND" ? data.type === "NORMAL" : true;
          })?.map((item, index, arr) => /* @__PURE__ */ React.createElement("div", {
            key: index,
            style: {
              borderBottom: arr.length > 1 && index !== arr.length - 1 ? "1px dotted #ddd" : "0"
            }
          }, /* @__PURE__ */ React.createElement(Tooltip, {
            placement: "topLeft",
            title: item.warehouseShelfCode === "" ? formatMessage({id: "noShelf"}) : item.warehouseShelfCode || "-"
          }, item.warehouseShelfCode === "" ? formatMessage({id: "noShelf"}) : item.warehouseShelfCode || "-", /* @__PURE__ */ React.createElement(Typography.Paragraph, {
            ellipsis: {rows: 1, expandable: false}
          })))));
        }
      } else {
        if (!(Array.isArray(record.shelfInventoryList) && record.shelfInventoryList.length)) {
          return "-";
        } else {
          return /* @__PURE__ */ React.createElement(React.Fragment, null, record.shelfInventoryList?.filter((data) => {
            return props.orderType === "OUTBOUND" ? data.type === "NORMAL" : true;
          })?.map((item, index, arr) => /* @__PURE__ */ React.createElement("div", {
            key: index,
            style: {
              borderBottom: arr.length > 1 && index !== arr.length - 1 ? "1px dotted #ddd" : "0"
            }
          }, /* @__PURE__ */ React.createElement(Tooltip, {
            placement: "topLeft",
            title: item.warehouseShelfCode === "" ? formatMessage({id: "noShelf"}) : item.warehouseShelfCode || "-"
          }, item.warehouseShelfCode === "" ? formatMessage({id: "noShelf"}) : item.warehouseShelfCode || "-", /* @__PURE__ */ React.createElement(Typography.Paragraph, {
            ellipsis: {rows: 1, expandable: false}
          })))));
        }
      }
    }
  }), /* @__PURE__ */ React.createElement(Table.Column, {
    title: formatMessage({id: "warehouseStockColumnName"}),
    dataIndex: "warehouseStock",
    width: 90,
    ellipsis: {showTitle: false},
    render: (text, record) => {
      if (props.orderType === "INBOUND") {
        let shelfInventoryBriefList = record.warehouseInventoryBriefs[0]?.shelfInventoryBriefList;
        if (!(Array.isArray(record.warehouseInventoryBriefs) && record.warehouseInventoryBriefs.length && record.warehouseInventoryBriefs[0]?.shelfInventoryBriefList)) {
          return /* @__PURE__ */ React.createElement("div", {
            style: {
              paddingBottom: "1em"
            }
          }, "-");
        } else {
          return /* @__PURE__ */ React.createElement(React.Fragment, null, shelfInventoryBriefList.map((item, index, arr) => /* @__PURE__ */ React.createElement("div", {
            key: index,
            style: {
              paddingBottom: "1em",
              borderBottom: arr.length > 1 && index !== arr.length - 1 ? "1px dotted #ddd" : ""
            }
          }, item.warehouseStock ?? "-")));
        }
      } else {
        if (!(Array.isArray(record.shelfInventoryList) && record.shelfInventoryList.length)) {
          return /* @__PURE__ */ React.createElement("div", {
            style: {
              paddingBottom: "1em"
            }
          }, "-");
        } else {
          return /* @__PURE__ */ React.createElement(React.Fragment, null, record.shelfInventoryList?.filter((data) => {
            return props.orderType === "OUTBOUND" ? data.type === "NORMAL" : true;
          })?.map((item, index, arr) => /* @__PURE__ */ React.createElement("div", {
            key: index,
            style: {
              paddingBottom: "1em",
              borderBottom: arr.length > 1 && index !== arr.length - 1 ? "1px dotted #ddd" : ""
            }
          }, item.warehouseStock ?? "-")));
        }
      }
    }
  }), /* @__PURE__ */ React.createElement(Table.Column, {
    title: formatMessage({id: "action1"}),
    width: 160,
    fixed: "right",
    dataIndex: "actionsColumn",
    render: (text, record, index) => {
      if (props.orderType === "INBOUND") {
        if (!(Array.isArray(record.warehouseInventoryBriefs) && record.warehouseInventoryBriefs.length && record.warehouseInventoryBriefs[0]?.shelfInventoryBriefList)) {
          if (props.selectedSkuList.some((item1) => {
            return item1.masterVariationId === record.masterVariationId;
          })) {
            return /* @__PURE__ */ React.createElement("div", {
              style: {
                paddingBottom: "1em"
              }
            }, formatMessage({id: "selected"}));
          } else {
            if (props.orderType === "OUTBOUND") {
              return /* @__PURE__ */ React.createElement("div", {
                style: {paddingBottom: "1em"}
              }, "-");
            } else {
              if (props.selectedWarehouse?.type === "THIRD_PARTY_WAREHOUSE") {
                return /* @__PURE__ */ React.createElement("div", {
                  style: {
                    paddingBottom: "1em"
                  }
                }, formatMessage({id: "pleaseAddProductFirst"}));
              } else {
                return /* @__PURE__ */ React.createElement("div", {
                  style: {
                    paddingBottom: "calc(1em - 2px)"
                  }
                }, /* @__PURE__ */ React.createElement(Button, {
                  onClick: () => {
                    handleAddProductToWarehouse(record, index);
                  },
                  style: {
                    padding: 0,
                    height: "auto"
                  },
                  type: "link"
                }, formatMessage({id: "addToWarehouse"})));
              }
            }
          }
        } else {
          return /* @__PURE__ */ React.createElement(React.Fragment, null, record.warehouseInventoryBriefs[0].shelfInventoryBriefList.map((item, index2, arr) => /* @__PURE__ */ React.createElement("div", {
            key: index2
          }, props.selectedSkuList.some((item1) => {
            return item1.masterVariationId === record.masterVariationId && item1.shelfInventoryId === item.shelfInventoryId;
          }) ? /* @__PURE__ */ React.createElement("div", {
            style: {
              paddingBottom: "1em",
              borderBottom: arr.length > 1 && index2 !== arr.length - 1 ? "1px dotted #ddd" : ""
            }
          }, formatMessage({id: "selected"})) : /* @__PURE__ */ React.createElement("div", {
            style: {
              paddingBottom: "calc(1em - 2px)",
              borderBottom: arr.length > 1 && index2 !== arr.length - 1 ? "1px dotted #ddd" : ""
            }
          }, /* @__PURE__ */ React.createElement(Button, {
            onClick: () => {
              props.onSelectSku({
                ...record,
                ...item,
                ...record.warehouseInventoryBriefs[0],
                fromAddProductModal: true
              });
            },
            style: {
              padding: 0,
              height: "auto"
            },
            type: "link"
          }, formatMessage({id: "select"}))))));
        }
      } else {
        if (!(Array.isArray(record.shelfInventoryList) && record.shelfInventoryList.length && record.warehouseInventory?.enableStatus !== "REGISTER_SHELF")) {
          return /* @__PURE__ */ React.createElement("div", {
            style: {paddingBottom: "1em"}
          }, "-");
        } else {
          return /* @__PURE__ */ React.createElement(React.Fragment, null, record.shelfInventoryList?.filter((data) => {
            return props.orderType === "OUTBOUND" ? data.type === "NORMAL" : true;
          })?.map((item, index2, arr) => /* @__PURE__ */ React.createElement("div", {
            key: index2
          }, props.selectedSkuList.some((item1) => {
            return item1.masterVariationId === record.masterVariation?.id && item1.shelfInventoryId === item.id;
          }) ? /* @__PURE__ */ React.createElement("div", {
            style: {
              paddingBottom: "1em",
              borderBottom: arr.length > 1 && index2 !== arr.length - 1 ? "1px dotted #ddd" : ""
            }
          }, formatMessage({id: "selected"})) : /* @__PURE__ */ React.createElement("div", {
            style: {
              paddingBottom: "calc(1em - 2px)",
              borderBottom: arr.length > 1 && index2 !== arr.length - 1 ? "1px dotted #ddd" : ""
            }
          }, /* @__PURE__ */ React.createElement(Button, {
            onClick: () => {
              props.onSelectSku({
                ...record,
                ...item,
                inventoryName: record.masterVariation?.name || "",
                sku: record.masterVariation?.masterSku || "",
                variationImages: [record.masterVariation?.image || ""],
                masterProductId: record.masterVariation?.masterProductId || "",
                masterVariationId: record.masterVariation?.id || "",
                shelfInventoryId: item.id || "",
                shelfInventoryBriefList: record.shelfInventoryList?.map((siItem) => ({
                  ...siItem,
                  shelfInventoryId: siItem.id || ""
                })),
                warehouseId: record.warehouseInventory?.warehouseId,
                warehouseInventoryId: record.warehouseInventory?.id,
                fromAddProductModal: true
              });
            },
            style: {
              padding: 0,
              height: "auto"
            },
            type: "link"
          }, formatMessage({id: "select"}))))));
        }
      }
    }
  })));
};
const Wrapper = styled.div.attrs({
  className: "main-content"
})`
  padding-left: 16px;
  padding-right: 16px;
  background-color: #fff;
  border: 1px solid #dfe3e8;
  .ant-table-cell {
    vertical-align: text-top;
  }

  .product-time-title {
    font-size: 12px;
    font-family: SFProText-Regular, SFProText;
    font-weight: 400;
    color: #202d40;
    line-height: 18px;
  }
  .product-time-content {
    font-size: 12px;
    font-family: SFProText-Regular, SFProText;
    font-weight: 400;
    color: #606c80;
    line-height: 18px;
  }
  .product-time-title + .product-time-content {
    margin-top: 4px;
  }
  .variation-row-wrapper {
    .variation-row {
      padding-bottom: 16px;
      padding-top: 16px;
    }
    .variation-col {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .variation-line {
      border-bottom: 1px dashed #adbacc;
    }
    &:first-child .variation-row {
      padding-top: 0;
    }
    &:last-child .variation-row {
      padding-bottom: 0;
    }
    &:last-child .variation-line {
      display: none;
    }
  }
`;
